import { createTranslationResource } from '@backstage/core-plugin-api/alpha';
import { createTranslationRef } from '@backstage/core-plugin-api/alpha';


export const pagesTranslationRef = createTranslationRef({
    id: 'caise.pages',
    messages: {
        pages: {
            keySuffix: '_en',
            experiments: 'Experiments',
            development: 'Development',
            objectStorage: 'Object storage',
            downloadApiKeys: 'Download API keys',
            services: 'Services',
            service: 'Service',
            signIn: 'Sign in',
            headers: {
                'overview': 'Overview',
            },
            objectBrowser: {
                action: {
                    'copy': 'Copy',
                    'createFolder': 'Create folder',
                    'delete': 'Delete',
                    'download': 'Download',
                    'upload': 'Upload',
                },
                'addFilesLabel': 'Add files',
                'addFolderLabel': 'Add folder',
                'allFilesCoped': 'All files copied.',
                'allFilesDeleted': 'All files deleted.',
                'allFilesDownloaded': 'All files downloaded.',
                'allFilesFailedToCopy': 'All files failed to copy.',
                'allFilesFailedToDelete': 'All files failed to delete.',
                'allFilesFailedToDownload': 'All files failed to download.',
                'allFilesUploaded': 'All files uploaded.',
                'cancelLabel': 'Cancel',
                copy: {
                    'destinationLabel': 'Copy destination',
                    'searchPlaceholder': 'Search for folders',
                    'title': 'Copy',
                },
                createFolder: {
                    'title': 'Create folder',
                },
                date: {
                    'locale': 'en-US',
                    'hourCycle': 'h12',  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getHourCycles
                },
                'delete': {
                    'title': 'Delete',
                },
                'destinationLabel': 'Destination',
                'downloadFile': 'Download {{fileName}}',
                download: {
                    'title': 'Download',
                },
                'errorLoadingFolders': 'Error loading folders.',
                'exitLabel': 'Exit',
                'failedCreateFolder': 'There was an issue creating the folder.',
                filePreview: {
                    'closeButtonLabel': 'Close',
                    'filePreviewTitle': 'File Preview',
                    'fileInformationTitle': 'File Information',
                    'errorMessage': 'Something went wrong',
                    'sizeLimitMessage': 'File preview not possible due to preview size limit',
                    'unsupportedFileMessage': 'File preview not supported for this file type',
                    'keyLabel': 'Key',
                    'sizeLabel': 'Size',
                    'versionIdLabel': 'Version Id',
                    'lastModifiedLabel': 'Last Modified',  // actual date is formatted with toLocaleString so is based on language selected in browser
                    'entityTagLabel': 'Entity tag',
                    'typeLabel': 'Type',
                    'unknownValue': 'Unknown',
                    'errorDescription': 'We encountered an issue while loading the file preview.',
                    'unsupportedFileDescription': 'This file format is not supported for preview. You can download the file to view it with an appropriate application.',
                    'imageLoadErrorDescription': 'The image could not be loaded. This may be due to network issues, file corruption, or an unsupported image format.',
                    'videoLoadErrorDescription': 'The video could not be played. This may be due to network issues, file corruption, or an unsupported video format or codec.',
                    'textLoadErrorDescription': 'The text file could not be loaded. This may be due to network issues, file access permissions, or the file being too large to display.',
                    'generalPreviewErrorDescription': 'An unexpected error occurred while loading the file preview. Please try again or download the file to view it with an appropriate application.',
                    'fileSizeLimitDescription': 'This file is too large to preview in the browser. You can download the file to view it with an appropriate application.',
                    'filePrefix': 'File: ',
                    'retryButtonLabel': 'Retry',
                    'downloadButtonLabel': 'Download',
                    'getTextErrorMessage': 'Error loading file: {{error}}',
                    'emptyFileMessage': 'File is empty',
                },
                'filesTooBig': 'Files larger than 160GB cannot be added to the upload queue: {{filenames}}',
                'folderAlreadyExists': 'A folder already exists with the provided name',
                'folderCreated': 'Folder created.',
                'folderNameLabel': 'Folder name',
                'folderNamePlaceholder': 'Folder name cannot contain "/", nor end or start with "."',
                'getValidationMessage': 'Folder name cannot contain "/", nor end or start with "."',
                'loadingIndicatorLabel': 'Loading',
                locationDetail: {
                    'defaultErrorMessage': 'There was an error loading items.',
                    'searchPlaceholder': 'Search current folder',
                },
                locations: {
                    'defaultErrorMessage': 'There was an error loading locations.',
                    'searchPlaceholder': 'Filter folders and files',
                    'title': 'Home',
                },
                'noFiles':'No files.',
                'noFoldersMatching': 'No folders found matching "{{query}}"',
                'noFoldersOrFiles': 'No folders or files.',
                'noResultsButTruncated': 'No results found in the first 10,000 items.',
                'noSubfoldersFound': 'No subfolders found within selected folder.',
                'overwriteToggleLabel': 'Overwrite existing files',
                'overwriteWarningMessage': 'Copied files will overwrite existing files at selected destination.',
                permissions: {
                    'read': 'Read',
                    'readWrite': 'Read/Write',
                    'write': 'Write',
                },
                'resultsTruncated':  'Showing results for up to the first 10,000 items.',
                'searchClearLabel': 'Clear search',
                'searchSubfoldersToggleLabel': 'Include subfolders',
                'searchSubmitLabel': 'Submit',
                'selectAllFilesLabel': 'Select all files',
                'selectFileLabel': 'Select file',
                'selectFolderLabel': 'Select folder',
                'someFilesFailedToCopy': '{{complete}} files copied, {{failed}} files failed to copy.',
                'someFilesFailedToDelete': '{{complete}} files deleted, {{failed}} files failed to delete.',
                'someFilesFailedToDownload': '{{complete}} files downloaded, {{failed}} files failed to download.',
                'statusDisplayCanceledLabel': 'Canceled',
                'statusDisplayCompletedLabel': 'Completed',
                'statusDisplayFailedLabel': 'Failed',
                'statusDisplayInProgressLabel': 'In progress',
                'statusDisplayOverwritePreventedLabel': 'Overwrite prevented',
                'statusDisplayQueuedLabel': 'Not started',
                'statusDisplayTotalLabel': 'Total',
                'tableColumnActionsHeader': 'Actions',
                'tableColumnBucketHeader': 'Bucket',
                'tableColumnCancelHeader': '',
                'tableColumnFolderHeader': 'Folder',
                'tableColumnLastModifiedHeader': 'Last modified',
                'tableColumnNameHeader': 'Name',
                'tableColumnPermissionsHeader': 'Permissions',
                'tableColumnProgressHeader': 'Progress',
                'tableColumnSizeHeader': 'Size',
                'tableColumnStatusHeader': 'Status',
                'tableColumnTypeHeader': 'Type',
                upload: {
                    'canceled_one': '{{count}} upload canceled',
                    'canceled_few': '{{count}} uploads canceled',
                    'canceled_many': '{{count}} uploads canceled',
                    'canceled_other': '{{count}} uploads canceled',
                    'failed_one': '{{count}} file failed to upload',
                    'failed_few': '{{count}} files failed to upload',
                    'failed_many': '{{count}} files failed to upload',
                    'failed_other': '{{count}} files failed to upload',
                    'overwritePrevented_one': 'Overwrite prevented for {{count}} file',
                    'overwritePrevented_few': 'Overwrite prevented for {{count}} files',
                    'overwritePrevented_many': 'Overwrite prevented for {{count}} files',
                    'overwritePrevented_other': 'Overwrite prevented for {{count}} files',
                    'title': 'Upload',
                    'uploaded_one': '{{count}} file uploaded',
                    'uploaded_few': '{{count}} files uploaded',
                    'uploaded_many': '{{count}} files uploaded',
                    'uploaded_other': '{{count}} files uploaded',
                },
            },
            home: {
                'altPG': 'Logo of Gdansk University of Technology',
                'altTASK': 'Logo of Centre of Informatics Tricity Academic Supercomputer and networK',
                'altKPO': 'National Recovery Plan',
                'altPL': 'Republic of Poland',
                'altEU': 'Funded by the European Union NextGenerationEU',
                'title': 'CAISE Platform',
                'explore': 'Explore',
                'headerContent': 'Complete cloud-based solution for ML experimentation, development of AI-enabled applications and automated software deployment.',
                'experiments': 'Experiments',
                'development': 'Development',
                'services': 'Services',
                'moreResources': 'More resources:',
            },
        },
    },
});


export const pagesTranslations = createTranslationResource({
    ref: pagesTranslationRef,
    translations: {
        pl: () => import('./pages-pl'),
    },
});

